import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { Countries } from 'src/models/enum';

export const CountryCodeSelector = () => {
  const { t } = useTranslation();
  return (
    <DefaultFastSelectField
      label={t('dashboard.assets.addedit.main.generalinfo.fields.country.label')}
      fieldName="location.countryCode"
      options={[
        { value: Countries.de, label: t('general.country.germany') },
        { value: Countries.at, label: t('general.country.austria') },
      ]}
    />
  );
};
